import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  AbstractDeclarativeFieldComponent,
  FieldDeclaration,
} from '@fmnts/declarative-forms';

/**
 * View that can be used as a fallback for fields that are unknown
 * meaning that they don't have a dedicated view yet.
 */
@Component({
  selector: 'declarative-unknown-field',
  template: '<p>Unknown: <code>{{ field.widget }}</code> ({{ field.key }})</p>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UnknownFieldComponent extends AbstractDeclarativeFieldComponent<FieldDeclaration> {}
